export const DEFAULT_PRODUCT_IMAGE = 'assets/default.webp';

const BLANK_IMAGE =
  'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

export function applyImageFallback(
  event: Event,
  fallbackSrc = DEFAULT_PRODUCT_IMAGE,
): void {
  const img = event.target as HTMLImageElement | null;
  if (!img) {
    return;
  }

  if (img.dataset['fallbackApplied'] === 'final') {
    img.onerror = null;
    return;
  }

  if (img.dataset['fallbackApplied'] === 'true') {
    img.dataset['fallbackApplied'] = 'final';
    img.onerror = null;
    img.src = BLANK_IMAGE;
    return;
  }

  img.dataset['fallbackApplied'] = 'true';
  img.src = fallbackSrc;
}
